import { showController } from '../show-controller/index';
const win: any = window;
const isUse = showController('hitNewStock');
/**
 * 获取客户端新债开关状态
 */
export const getClientBondSwitch = (success: Function) => {
    if (isUse) {
        win.callNativeHandler('fetchXinZhaiSwitchState', {},
            (data: any) => {
                const res = data.bondSwitch;
                success && success(res);
            }
        );
        return;
    }
    success && success(true);
    return;
}

/**
 * 同步更新客户端新债开关状态
 */
export const setClientBondSwitch = (flag: boolean) => {
    if (isUse) {
        win.callNativeHandler('updateXinZhaiSwitchState', 
            {
                'bondSwitch': flag,
            }
        );
        return;
    }
    return;
}